/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { lazy } from 'react';
import { useInlineContext } from '../../../context/inline';
import { getChildrenText } from '../utils/getChildrenText';
var styles = css({
  width: "'100%'"
});
var AKCodeBlock = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.code' */
  '@atlaskit/code').then(function (module) {
    return {
      AkCode: module.Code,
      AkCodeBlock: module.CodeBlock
    };
  }).then(function (module) {
    return {
      default: module.AkCodeBlock
    };
  });
});
var AKCodeInline = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.code' */
  '@atlaskit/code').then(function (module) {
    return {
      AkCode: module.Code,
      AkCodeBlock: module.CodeBlock
    };
  }).then(function (module) {
    return {
      default: module.AkCode
    };
  });
});
export var Code = function Code(_ref) {
  var _ref$forgeDoc = _ref.forgeDoc,
    props = _ref$forgeDoc.props,
    children = _ref$forgeDoc.children;
  var _ref2 = props,
    language = _ref2.language,
    showLineNumbers = _ref2.showLineNumbers;
  var text = getChildrenText(children);
  var _useInlineContext = useInlineContext(),
    inline = _useInlineContext.inline;
  return inline ? jsx(AKCodeInline, null, text) : jsx("div", {
    css: styles
  }, jsx(AKCodeBlock, {
    text: text,
    language: language,
    showLineNumbers: showLineNumbers
  }));
};